import { apiClient } from '@/lib/api/client'
import type { Size } from '@/types/entities'

export const sizeApi = {
  getAllSizes: async (): Promise<Size[]> => {
    const response = await apiClient.get('/api/sizes')
    return response.data
  },

  getSize: async (sizeId: number): Promise<Size> => {
    const response = await apiClient.get(`/api/sizes/${sizeId}`)
    return response.data
  },
}

